import { getAssetPath, h } from '@stencil/core'
import { FunctionalComponent, JSXBase } from '@stencil/core/internal'
import { css } from 'src/lib/emotion'

import { classes } from '../../utils/css'

export type LogoFn = FunctionalComponent<{ inactive?: boolean } & JSXBase.IntrinsicElements['img']>

const inactiveStyle = css`
  transition: all 0.2s linear;
  filter: grayscale();
  opacity: 0.5;
  &:hover {
    opacity: 1;
    filter: none;
  }
`

const Logo: LogoFn = ({ inactive, class: className = '', ...attrs }) => (
  <img {...attrs} class={`${className} ${classes(inactive, inactiveStyle)}`} />
)

export const SlackLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/slack.svg')} />
export const ZoomLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/zoom.svg')} />
export const GoogleMeetLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/google_meet.svg')} />
export const MSTeamsLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/ms_teams.svg')} />
export const FathomLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/fathom.svg')} />
export const ChromeLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/chrome.svg')} />
export const ZapierLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/zapier.svg')} />

export const ChurnZeroLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/churnzero.svg')} />
export const CloseioLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/closeio.svg')} />
export const GainsightLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/gainsight.svg')} />
export const HubspotLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/hubspot.svg')} />
export const MicrosoftLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/microsoft.svg')} />
export const PipedriveLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/pipedrive.svg')} />
export const SalesforceLogo: LogoFn = (props) => <Logo {...props} src={getAssetPath('./assets/salesforce.svg')} />
